// src/components/layout/Layout.tsx
import { Outlet, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Header } from './Header'
import { Footer } from './Footer'
import { CinematicCTA } from '@/components/sections/CinematicCTA'
import { CookieConsent } from '@/components/CookieConsent'
import { ChatBot } from '@/components/ChatBot'
import { localizedRoutes } from '@/i18n/routes'

// Pagine che non mostrano il CTA finale (raccolte dinamicamente da tutte le lingue)
const routeKeysWithoutCTA = ['contacts', 'work', 'breweries', 'privacy', 'whistleblowing', 'accessibility', 'reservedArea'] as const
const pagesWithoutCTA = new Set<string>(
  routeKeysWithoutCTA.flatMap(key =>
    Object.values(localizedRoutes[key]).filter(Boolean) as string[]
  )
)

export function Layout() {
  const { t } = useTranslation()
  const location = useLocation()

  // Estrai lo slug della pagina corrente
  const pathSegments = location.pathname.split('/').filter(Boolean)
  const currentSlug = pathSegments[1] || ''

  // Determina se mostrare il CTA
  const showCTA = !pagesWithoutCTA.has(currentSlug)

  return (
    <>
      {/* Skip to content per accessibilità */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:bg-white focus:text-brand-dark focus:px-4 focus:py-2 focus:rounded"
      >
        {t('aria.skipToContent', 'Vai al contenuto')}
      </a>

      <Header />

      <main id="main-content">
        <Outlet />
      </main>

      {showCTA && <CinematicCTA />}

      <Footer />

      <CookieConsent />

      <ChatBot />
    </>
  )
}
